import React, { useState, useEffect } from "react";
import ViewBill from "../../../../../entities/DashboardPage/AccountingModule/Supplier/BillView";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";

const ViewBillPage = () => {
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { item } = state || {};
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    getViewBill()
  }, []);

  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.handleDownloadBill(item?._id);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getViewBill = async () => {
    const result = await AuthService.getBillView(item?._id);
    return { __html: result };
  };


  return (
    <ViewBill handleDownload={handleDownload} loading={loading} getViewBill={getViewBill} />
  )

}

export default ViewBillPage;
